document.addEventListener("DOMContentLoaded", function () {
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
      Toolbar: {
        absolute: false,
        display: {
          middle: ["counter"],
          right: ["toggleFull", "close"],
        },
      },
      Thumbs: {
        type: "classic",
      },
    },
  });
});
//variant read more js-------------------start
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.ctm-pills-read-more');
  if (!btn) return;

  const container = btn.closest('.ctm-variant-inputs-1');
  if (!container) return;

  const isExpanded = container.classList.toggle('is-expanded');
  btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');

  const textEl = btn.querySelector('.ctm-pills-read-more__text');
  if (textEl) {
    textEl.textContent = isExpanded
      ? textEl.dataset.textLess
      : textEl.dataset.textMore;
  }
});
//variant read more js-------------------end

//===========================================================================================================================================
document.addEventListener("DOMContentLoaded", function () {
  let navigationBtn = document.querySelectorAll('.cus-navigation-button');
  let navigationMegaMenu = document.querySelectorAll('.cus-drop_down-effect');
  let addAtribute = document.querySelectorAll('.add-atribue_open');
  let navLi = document.querySelectorAll('.cus-navigation-button');
  let headerSvg = document.querySelectorAll('.header_svg_icon');

  navigationBtn.forEach((btn, index) => {
    btn.addEventListener('mouseover', () => {
      console.log(`Hovered over button ${index + 1}`);

      // Hide all mega menus before showing the one related to the hovered button
      navigationMegaMenu.forEach((menu) => {
        menu.classList.remove('active');
      });



      // Add 'active' class to the corresponding mega menu based on the index
      if (headerSvg[index]) {
        headerSvg[index].classList.add('active');
        console.log(`Activated mega menu ${index + 1}`);
      }
      if (navigationMegaMenu[index]) {
        navigationMegaMenu[index].classList.add('active');
        console.log(`Activated mega menu ${index + 1}`);
      }

      // Add 'open' attribute to the corresponding element in addAtribute based on the index
      if (addAtribute[index]) {
        addAtribute[index].setAttribute('open', '');  // Correct method: setAttribute
        console.log(`Added 'open' attribute to element ${index + 1}`);
      }
    });

    navigationMegaMenu[index]?.addEventListener('mouseleave', () => {
      if (navigationMegaMenu[index]) {
        navigationMegaMenu[index].classList.remove('active');
        console.log(`Deactivated mega menu ${index + 1}`);
      }

      setTimeout(() => {
        if (addAtribute[index]) {
          addAtribute[index].removeAttribute('open');
          console.log(`Removed 'open' attribute from element ${index + 1}`);
        }

        if (navLi[index]) {
          navLi[index].classList.remove('active');
          console.log(`Removed 'active' class from navigation button ${index + 1}`);
        }
      }, 500);
    });

  });



  document.querySelectorAll('.tab_heading_hover').forEach(tab => {
    const titleCode = tab.getAttribute('data-title-code');
    console.log('Tab titleCode:', titleCode);
    tab.addEventListener('mouseenter', function () {
      document.querySelectorAll('.tab_heading_hover a').forEach(singleatag => {
        singleatag.classList.remove('hoverclassactive');
      });
      this.querySelector('a').classList.add('hoverclassactive');
      showMyChild(titleCode);
    });
  });

  const items = document.querySelectorAll('.cus-position_change');
  items.forEach((item, index) => {
    item.style.borderRight = '1px solid #D5DFE1';
    if (index === items.length - 1) {
      item.style.borderRight = 'none';
    }
  });

});



function showMyChild(attribute) {
  console.log('Showing section for:', attribute);


  const targetSection = document.getElementById(`show-image-section-${attribute}`);
  console.log('Target section:', targetSection);

  if (targetSection) {
    document.querySelectorAll('.addclassattri').forEach(section => {
      section.style.display = 'none';
    });
    targetSection.style.display = 'block';
  } else {
    console.log(`No section found for ${attribute}`);
  }
}

function updateCountdown() {
  let parent = document.querySelector('.delivery-widget.mid-night-timer-active .countdown-box')
  if (parent) {
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0);
    const timeDifference = tomorrow - now;
    const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDifference / 1000) % 60);
    parent.querySelector("#days").textContent = "0";
    parent.querySelector("#hours").textContent = String(hours).padStart(2, "0");
    parent.querySelector("#minutes").textContent = String(minutes).padStart(2, "0");

    parent.querySelector("#seconds").textContent = String(seconds).padStart(2, "0");
    return;
  }

  const countdownElement = document.querySelector('.delivery-widget.set-manual-countdown');
  if (countdownElement) {
    let targetDateTime = new Date(countdownElement.getAttribute('data-time-format'));

    if (isNaN(targetDateTime)) {
      targetDateTime = new Date();
      targetDateTime.setHours(0, 0, 0, 0);
    }

    const now = new Date();
    const timeDifference = targetDateTime - now;

    if (timeDifference > 0) {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      document.getElementById('days').textContent = days;
      document.getElementById('hours').textContent = hours < 10 ? '0' + hours : hours;
      document.getElementById('minutes').textContent = minutes < 10 ? '0' + minutes : minutes;
      document.getElementById('seconds').textContent = seconds < 10 ? '0' + seconds : seconds;
    } else {
      document.getElementById('days').textContent = 0;
      document.getElementById('hours').textContent = '00';
      document.getElementById('minutes').textContent = '00';
      document.getElementById('seconds').textContent = '00';
    }
  }


}

setInterval(updateCountdown, 1000);
updateCountdown();


$(document).ready(function () {

  document.querySelector('variant-selects')?.addEventListener('change', () => {
    console.log(' update occur in variant');
    for (let i = 1; i <= 3; i++) {
      setTimeout(updateTotalPrice, i * 500);
    }
  })

  function syncVariantSelection() {
    $('.upsell__variant-picker').each(function () {
      const $picker = $(this);
      const width = $picker.find('select[name="options[Širina vzmetnice]"]').val();
      const length = $picker.find('select[name="options[Dolžina vzmetnice]"]').val();

      if (width && length) {
        const variantKey = `${width} / ${length}`;
        const matchingInput = $picker.find(`input[type="hidden"][name="${variantKey}"]`);
        const variantId = matchingInput.val();

        if (variantId) {
          console.log('Matched Variant:', variantKey, '| ID:', variantId);

          // Go to the closest parent <product-info-upsell> and update the data-id
          const $upsellComponent = $picker.closest('product-info-upsell');
          $upsellComponent.attr('data-id', variantId);

          // Also update the hidden input[name="id"] inside the form if needed
          $upsellComponent.find('input[name="id"]').val(variantId);
        }
      }
    });
    setTimeout(function () {
      updateTotalPrice();
    }, 2500);

  }

  // Get the selected width and length from the inputs on page load
  const selectedWidth = $('input[name="Širina vzmetnice"]:checked').val();
  const selectedLength = $('input[name="Dolžina vzmetnice"]:checked').val();

  if (selectedWidth || selectedLength) {
    // Set the selected values on the respective select elements
    if (selectedWidth) {
      $('product-info-upsell select[name="options[Širina vzmetnice]"]').val(selectedWidth).trigger('change');
    }
    if (selectedLength) {
      $('product-info-upsell select[name="options[Dolžina vzmetnice]"]').val(selectedLength).trigger('change');
    }

    // Perform the variant sync
    syncVariantSelection();
  }

  // Event listener for width change
  // $('input[name="Širina vzmetnice"]').on('change', function () {
  //   const selectedWidth = $(this).val();
  //   $('product-info-upsell select[name="options[Širina vzmetnice]"]').val(selectedWidth).trigger('change');
  //   syncVariantSelection();
  // });

  $('input[name="Širina vzmetnice"]').on('change', function () {
    const selectedWidth = $(this).val();
    const $select = $('product-info-upsell select[name="options[Širina vzmetnice]"]');

    if ($select.find(`option[value="${selectedWidth}"]`).length > 0) {
      $select.val(selectedWidth).trigger('change');
      syncVariantSelection();
    } else {
      console.warn(`Invalid selection: ${selectedWidth} is not an available option.`);
    }
  });

  // Event listener for length change
  $('input[name="Dolžina vzmetnice"]').on('change', function () {
    const selectedLength = $(this).val();
    const $select = $('select[name="options[Dolžina vzmetnice]"]');
    if ($select.find(`option[value="${selectedLength}"]`).length > 0) {
      $select.val(selectedLength).trigger('change');
    } else {
      console.warn(`Invalid selection: ${selectedLength} is not an available option.`);
    }

    //   $('product-info-upsell select[name="options[Dolžina vzmetnice]"]').val(selectedLength).trigger('change');
    syncVariantSelection();
  });

  function updateTotalPrice() {
    
    if (!window.location.href.includes('products')) return;

    const allPrices = document.querySelectorAll('.product .price__container');

    if (allPrices.length > 1) {
      const firstContent = allPrices[0].innerHTML;
      allPrices.forEach((item, index) => {
        if (index !== 0) {
          
        console.log( 'inner ');
          item.innerHTML = firstContent;
        }
      });
    }


    let $mainProductPriceContainer = $('.main-product__info-container .price__container .price__regular');
    const salePrice = parseFloat($mainProductPriceContainer.find('.price-item--regular').text().trim().replace('€', '').replace(',', '.'));

    // new code for price updated --------------

    let priceText = '';
    const $mainProductPriceContainer1 = $('#custom-price-block'); // set this correctly
    const regularPriceEl = $mainProductPriceContainer1.find('.regular-price');
    const clubPriceEl = $mainProductPriceContainer1.find('#club-price');

    if (clubPriceEl.length) {
      priceText = clubPriceEl.text().trim(); // e.g., "Klubska cena: 150,00€"
    } else if (regularPriceEl.length) {
      priceText = regularPriceEl.text().trim();
    }

    // Extract number using regex (e.g., "150,00")
    const match = priceText.match(/[\d.,]+/);

    let price = 0;

    if (match) {
      // Convert European format to JS float (comma to dot)
      const normalized = match[0].replace(/\./g, '').replace(',', '.');
      price = parseFloat(normalized);
    }

    console.log('Parsed price:', price);

    // ------------------------


    console.log('salePrice: ', salePrice)

    const quantity = parseInt($('quantity-input .quantity__input').val(), 10);
    console.log('quantity: ', quantity)

    if (isNaN(quantity) || quantity < 1) return;

    let totalPrice = salePrice || price;
    console.log('totalPrice1:', totalPrice)

    if (quantity > 1) {
      console.log("quantity", quantity)
      totalPrice += (quantity - 1) * totalPrice;
    }
    console.log('totalPrice2:', totalPrice)

    $('product-info-upsell').each(function () {
      const $upsell = $(this);
      const upsellPrice = parseFloat($upsell.find('.upsell__price .regular-price').text().trim().replace('€', '').replace(',', '.'));
      const isChecked = $upsell.attr('data-selected') === 'true';

      if (isChecked) {
        totalPrice += upsellPrice;
      }
    });
    console.log('totalPrice3:', totalPrice)
    // Format and update subtotal
    const formattedTotal = totalPrice.toFixed(2).replace('.', ',') + '€ EUR';
    $('.price-subtotal span').text(formattedTotal);

    console.log({
      quantity,
      totalPrice,
      formattedTotal
    });
  }


  // Listen for quantity changes
  $('quantity-input .quantity__input').on('change', function () {
    updateTotalPrice();  // Update the total price whenever the quantity is updated
  });

  // Handle the upsell logic when toggling
  $('product-info-upsell .upsell__toggle-switch').on('click', function () {
    const $upsell = $(this).closest('product-info-upsell');  // Get the closest upsell container
    const $subtotalSpan = $('.price-subtotal span');  // Target the subtotal span element

    // Get the current total price from the subtotal span
    let currentTotal = parseFloat($subtotalSpan.text().replace('€ EUR', '').trim().replace(',', '.'));

    // Get the regular price from the upsell container (in euros, converted to float)
    const regularPrice = parseFloat($upsell.find('.upsell__price .regular-price').text().trim().replace('€', '').replace(',', '.'));

    // Check if the data-selected attribute is true or false
    const isChecked = $upsell.attr('data-selected') === 'true';

    // Update the data-selected attribute
    if (isChecked) {
      // Add the regular price to the current total when checked
      currentTotal += regularPrice;
    } else {
      // Subtract the regular price from the current total when unchecked
      currentTotal -= regularPrice;
    }

    // Format the new total price (with a comma and the EUR symbol)
    const formattedTotal = currentTotal.toFixed(2).replace('.', ',') + '€ EUR';

    // Update the subtotal span with the new price
    $subtotalSpan.text(formattedTotal);

    // Log for debugging purposes
    console.log({
      regularPrice: regularPrice,
      isChecked: isChecked,
      newTotal: formattedTotal
    });

    // Update total price after upsell toggle
    updateTotalPrice();
  });

  // Initialize the total price on page load
  updateTotalPrice();

});




// document.addEventListener("DOMContentLoaded", function () {
//     const productInfoContainer = document.querySelector(".product .product__info-wrapper");

//     if (productInfoContainer) {
//         const variantContainer = productInfoContainer.querySelector("variant-selects");
//         const formInputWrappers = variantContainer.querySelectorAll(".product-form__input");

//         formInputWrappers.forEach((inputWrapper) => {
//             const variantsInputs = inputWrapper.querySelectorAll("input");

//             variantsInputs.forEach((input) => {
//                 // const value = input.value;
//             });


//             const upsellContainer = productInfoContainer.querySelector(".product-info-upsells-container");
//             const upsellItems = upsellContainer.querySelector("product-info-upsell.upsell");
//             console.log(upsellItems);


//         });
//     }
// });

// sync add ons on variant selection

// document.addEventListener('DOMContentLoaded', function () {
//     const ctmVarSelection = document.querySelector('.ctm-variant-inputs-2')
//     // on change selection
//     ctmVarSelection.addEventListener('change', function (e) {
//         const ctmSelVarVal = ctmVarSelection.querySelector('.ctm-selected-var-2');
//         if (ctmSelVarVal) {
//             const selectedval = e.target.value
//             console.log(selectedval);

//             document.querySelectorAll('.upsell__variant-picker').forEach((vars)=>{
//                 console.log(vars , 'vars')
//             })

//         }
//     })

//     // onload selection
//     // pending
// })

// document.addEventListener('DOMContentLoaded', function () {
//     const ctmVarSelection = document.querySelector('.ctm-variant-inputs-2');

//     ctmVarSelection.addEventListener('change', function (e) {
//         const selectedval = e.target.value.trim().replace(/\s+/g, ' ');
//         console.log('Selected value:', selectedval);

//         document.querySelectorAll('.select__select.variant-dropdown').forEach(select => {
//             Array.from(select.options).forEach(option => {
//                 if (option.value.trim().replace(/\s+/g, ' ') === selectedval) {
//                     select.value = option.value;
//                     select.dispatchEvent(new Event('change')); 
//                 }
//             });
//         });
//     });
// });
// document.addEventListener('DOMContentLoaded', function () {
//     const ctmVarSelection = document.querySelector('.ctm-variant-inputs-2');

//     ctmVarSelection.addEventListener('change', function (e) {
//         const selectedval = e.target.value.trim().replace(/\s+/g, ' ');

//         document.querySelectorAll('.upsell__variant-picker').forEach(picker => {
//             const inputs = picker.querySelectorAll('input');

//             inputs.forEach(input => {
//                 const inputName = input.getAttribute('name')?.trim().replace(/\s+/g, ' ');
//                 const inputValue = input.value;

//                 if (inputName === selectedval) {
//                     const productInfo = picker.closest('product-info-upsell');
//                     if (productInfo) {
//                         productInfo.setAttribute('data-id', inputValue);
//                         console.log(`Set data-id to "${inputValue}" for`, productInfo);
//                     }
//                 }
//             });
//         });
//     });
// });


document.addEventListener('DOMContentLoaded', function () {
  const ctmVarSelection = document.querySelector('.ctm-variant-inputs-2');

  function updateUpsellprds(selectedval) {
    document.querySelectorAll('.select__select.variant-dropdown').forEach(select => {
      Array.from(select.options).forEach(option => {
        const normalizedOption = option.textContent.trim().replace(/\s+/g, ' ');
        if (normalizedOption === selectedval) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));

          // ✅ Also update the variant ID in the closest form
          const form = select.closest('form');
          if (form) {
            const variantIdInput = form.querySelector('input[name="id"]');
            if (variantIdInput) {
              variantIdInput.value = option.value;
              console.log('Updated form variant ID to:', option.value);
            }
          }
        }
      });
    });
  }

  ctmVarSelection?.addEventListener('change', function (e) {
    const selectedval = e.target.value.trim().replace(/\s+/g, ' ');
    console.log('Selected custom variant:', selectedval);
    updateUpsellprds(selectedval)
  });
  const selectedVal = document.querySelector('.ctm-selected-var-2')?.textContent.split(' - ').pop().trim();
  console.log('selectedVal', selectedVal)
  updateUpsellprds(selectedVal);

});


// ------------------------------------------lightbox-video---------------------
// document.addEventListener('DOMContentLoaded', function() {
//   // Create lightbox elements
//   const lightbox = document.createElement('div');
//   lightbox.className = 'video-lightbox';
//   lightbox.style.display = 'none';
//   lightbox.style.position = 'fixed';
//   lightbox.style.top = '0';
//   lightbox.style.left = '0';
//   lightbox.style.width = '100%';
//   lightbox.style.height = '100%';
//   lightbox.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
//   lightbox.style.zIndex = '1000';
//   lightbox.style.overflowY = 'auto';
//   lightbox.style.alignItems = 'center';
//   lightbox.style.justifyContent = 'center';
//   lightbox.style.padding = '20px';
//   lightbox.style.boxSizing = 'border-box';

//   const lightboxContent = document.createElement('div');
//   lightboxContent.className = 'video-lightbox-content';
//   lightboxContent.style.position = 'relative';
//   lightboxContent.style.maxWidth = '90%';
//   lightboxContent.style.maxHeight = '90vh';
//   lightboxContent.style.width = 'auto';
//   lightboxContent.style.margin = 'auto';

//   const closeButton = document.createElement('button');
//   closeButton.innerHTML = '&times;';
//   closeButton.style.position = 'fixed';
//   closeButton.style.top = '20px';
//   closeButton.style.right = '20px';
//   closeButton.style.fontSize = '30px';
//   closeButton.style.color = 'white';
//   closeButton.style.background = 'none';
//   closeButton.style.border = 'none';
//   closeButton.style.cursor = 'pointer';
//   closeButton.style.zIndex = '1001';

//   lightbox.appendChild(closeButton);
//   lightbox.appendChild(lightboxContent);
//   document.body.appendChild(lightbox);

//   // Handle lightbox video playback (directly without thumbnail preview)
//   document.querySelectorAll('.internal-video__play').forEach(button => {
//     button.addEventListener('click', function(e) {
//       e.preventDefault();
//       const videoContainer = this.closest('internal-video');
//       const video = videoContainer.querySelector('video');

//       if (video) {
//         // Clone the video element to preserve original
//         const videoClone = video.cloneNode(true);
//         videoClone.controls = true;
//         videoClone.style.maxWidth = '100%';
//         videoClone.style.maxHeight = '90vh';
//         videoClone.style.width = 'auto';
//         videoClone.style.height = 'auto';
//         videoClone.style.display = 'block';

//         // Clear previous content and add new video
//         lightboxContent.innerHTML = '';
//         lightboxContent.appendChild(videoClone);

//         // Show lightbox
//         lightbox.style.display = 'flex';
//         document.body.style.overflow = 'hidden';

//         // Play video
//         videoClone.play().catch(error => {
//           console.error('Video play failed:', error);
//         });
//       }
//     });
//   });

//   // Close lightbox
//   closeButton.addEventListener('click', function() {
//     lightbox.style.display = 'none';
//     document.body.style.overflow = 'auto';

//     // Pause all videos in lightbox when closing
//     lightboxContent.querySelectorAll('video').forEach(video => {
//       video.pause();
//     });
//   });

//   // Close lightbox when clicking on backdrop
//   lightbox.addEventListener('click', function(e) {
//     if (e.target === lightbox) {
//       lightbox.style.display = 'none';
//       document.body.style.overflow = 'auto';

//       // Pause all videos in lightbox when closing
//       lightboxContent.querySelectorAll('video').forEach(video => {
//         video.pause();
//       });
//     }
//   });

//   // Exit fullscreen when video ends (original functionality preserved)
//   document.querySelectorAll('video').forEach(video => {
//     video.addEventListener('ended', function() {
//       if (document.fullscreenElement) {
//         document.exitFullscreen();
//       }
//     });
//   });
// });

//  -----------------------------play/pause-function----------------------

// document.addEventListener("DOMContentLoaded", function () {
//     const popupVideo = document.querySelector(
//       ".video-popup-modal-template--25117428580732__ss_video_pop_2_CJKd8B video"
//     );
//     const playPauseBtn = document.querySelector(".video-play-pause-button");
//     const playIcon = playPauseBtn?.querySelector(".play-icon");
//     const pauseIcon = playPauseBtn?.querySelector(".pause-icon");

//     let hideTimeout;

//     function toggleVideo() {
//       if (popupVideo.paused) {
//         popupVideo.play();
//       } else {
//         popupVideo.pause();
//       }
//     }

//     function updateButtonState() {
//       if (popupVideo.paused) {
//         // Show play icon and keep button visible
//         playIcon.style.display = "block";
//         pauseIcon.style.display = "none";
//         playPauseBtn.style.opacity = "1";
//         clearTimeout(hideTimeout);
//       } 
//       else {
//         // Show pause icon briefly then hide
//         playIcon.style.display = "none";
//         pauseIcon.style.display = "block";
//         playPauseBtn.style.opacity = "1";
//         clearTimeout(hideTimeout);
//         hideTimeout = setTimeout(() => {
//           playPauseBtn.style.opacity = "0";
//         }, 2000);
//       }
//     }

//     if (popupVideo && playPauseBtn) {
//       // Toggle playback on video or button click
//       popupVideo.addEventListener("click", toggleVideo);
//       playPauseBtn.addEventListener("click", function (e) {
//         e.stopPropagation(); // Prevent video click from firing
//         toggleVideo();
//       });

//       // Update button state when video plays/pauses
//       popupVideo.addEventListener("play", updateButtonState);
//       popupVideo.addEventListener("pause", updateButtonState);
//     }
//   });


document.addEventListener("DOMContentLoaded", function () {
  const popupVideo = document.querySelector(".cstm-video-popup video");
  const playPauseBtn = document.querySelector(".video-play-pause-button");
  const playIcon = playPauseBtn?.querySelector(".play-icon");

  console.log('popupVideo', popupVideo);

  let hideTimeout;

  function toggleVideo() {
    if (popupVideo.paused) {
      popupVideo.play();
    } else {
      popupVideo.pause();
    }
  }

  function updateButtonState() {
    if (popupVideo.paused) {
      playIcon.style.display = "block";
      playPauseBtn.style.opacity = "1";
      clearTimeout(hideTimeout);
    } else {
      playIcon.style.display = "none";
      playPauseBtn.style.opacity = "1";
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => {
        playPauseBtn.style.opacity = "0";
      }, 2000);
    }
  }

  if (popupVideo && playPauseBtn) {
    popupVideo.addEventListener("click", toggleVideo);

    playPauseBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      toggleVideo();
    });

    popupVideo.addEventListener("play", updateButtonState);
    popupVideo.addEventListener("pause", updateButtonState);
  }
});


// ---------------------end-play/pause-function----------------------


// ------------------------------------------------video-popup-outside-click--------------
document.addEventListener('DOMContentLoaded', function () {
  // Get the elements
  const videoPopup = document.querySelector('.cus-video-popup');
  const videoPopupModal = document.querySelector('.cstm-video-popup');
  const videoElement = document.querySelector('.cstm-video-popup video');

  // Function to handle clicks outside the popup
  function handleClickOutside(event) {
    // Check if the click is outside both popup elements
    if (!videoPopup?.contains(event.target) && !videoPopupModal?.contains(event.target)) {
      // Remove the classes
      videoPopup?.classList.remove('video-hide');
      videoPopupModal?.classList.remove('active');

      // Pause the video
      if (videoElement) {
        videoElement.pause();
      }
    }
  }

  document.addEventListener('click', handleClickOutside);
});

if (window.innerWidth <= 1024) {
  document.addEventListener('click', (e) => {
    const cusVidModal = document.querySelector('.video-popup-style')
    cusVidModal.classList.add('.video-popup-style-js')
    if (!e.target.closest('.custom-popup-inner-modal') && e.target.closest('.video-popup-style')) {
      document.querySelector('.cus-cls-video-modal').click()
      cusVidModal.style.zIndex = -1;
    } else if (e.target.closest('.cus-video-popup')) {
      cusVidModal.style.zIndex = 5;
    }
    else if(e.target.closest('.cus-cls-video-modal')) {
      cusVidModal.style.zIndex = -1;
    }
  })
}



// const videoPlay = document.querySelectorAll('.internal-video__play')
// videoPlay.forEach(btn=>{
//   btn.addEventListener("click", function(e){
//     // e.preventDefault();
//     // e.stopPropagation();
//     console.log('clicked play btn', e.target)
//   })
// })

const videoPlay = document.querySelectorAll('.product .internal-video__play');

videoPlay.forEach(btn => {
  btn.addEventListener("click", function(e) {
    // Find the closest video inside the same container
    const videoContainer = btn.closest('.internal-video');
    const video = videoContainer.querySelector('video');

    if (video) {
      console.log('Before clearing:', video.src);
      video.src = ''; // Clear the video source
      video.load();   // Optionally reload to reflect the change
      console.log('After clearing:', video.src);
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const discountBlocks = document.querySelectorAll('.additional-discount-block');
  if (!discountBlocks.length) return;

  discountBlocks.forEach(discountBlock => {
    const extraDiscount = parseFloat(discountBlock.dataset.extraDiscount);
    const productPrices = JSON.parse(discountBlock.dataset.productPrices);
    const moneyFormat = discountBlock.dataset.moneyFormat;

    function updateDiscount(variantId) {
      let price = parseFloat(productPrices[variantId]);
      let discountAmount = price * (extraDiscount / 100);
      let finalPrice = price - discountAmount;

      const finalPriceElem = discountBlock.querySelector('.final-price-amount');
      if(finalPriceElem) finalPriceElem.textContent = formatMoney(finalPrice, moneyFormat);

      const extraDiscountElem = discountBlock.querySelector('.extra-discount');
      if(extraDiscountElem) extraDiscountElem.textContent = `(-${extraDiscount}%)`;
    }

    // Listen for variant changes
    document.addEventListener('change', function(e) {
      if (e.target.matches('[name="id"]')) {
        updateDiscount(e.target.value);
      }
    });

    // Initialize on page load
    const initialVariant = document.querySelector('[name="id"]');
    if (initialVariant) updateDiscount(initialVariant.value);
  });
});



